/**
 * Provides JS functionality for tracking alert display.
 */
export class IconCards extends DrupalBehavior {
  onContent(context) {
    const iconCard = context.querySelector('.icon-card');

    if (iconCard) {
      const cards = context.querySelectorAll('.icon-card');

      cards.forEach((card) => {
        const link = card.querySelector('a');

        if (link.getAttribute('href') === '/appointment') {
          const links = card.querySelectorAll('a');
          links.forEach((element) => {
            element.setAttribute('data-dialog-type', 'modal');
            element.classList.add('use-ajax');
          });
        }
      });
    }
  }
}

DrupalBehavior.register('rush_theme.components', 'icon_cards', IconCards);
